import React from "react";
import { useNavigate } from "react-router-dom";
import Popup from "./Popup";
import { Info } from "../../../public/icons";
import { Btn } from "../../styles/Button.styled";
import { Container } from "../../styles/Sidebar/UploadModal.styled";

export default function VerifyEmailModal() {
  const navigate = useNavigate();

  return (
    <Popup style={{ height: "max-content", maxWidth: "420px", textAlign: "center" }}>
      <Container style={{ alignItems: "center", gap: "16px", paddingBottom: "8px" }}>
        <div style={iconWrapStyle}>
          <Info size={36} color="var(--blue)" />
        </div>

        <h2 style={titleStyle}>Підтвердіть електронну адресу</h2>

        <p style={descStyle}>
          Для повноцінної роботи з системою необхідно верифікувати вашу
          електронну адресу.
        </p>
        <p style={descStyle}>Перейдіть до вашої поштової скриньки — ми надіслали листа з посиланням для підтвердження.</p>

        <Btn
          type="button"
          $background="var(--blue)"
          $color="var(--white)"
          $width="100%"
          $marginTop="0"
          onClick={() => navigate("/settings/account")}
        >
          Перейти до налаштувань
        </Btn>
      </Container>
    </Popup>
  );
}

const iconWrapStyle: React.CSSProperties = {
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  background: "var(--sidebar-hover)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const titleStyle: React.CSSProperties = {
  fontSize: "20px",
  fontWeight: 700,
  color: "var(--dark)",
  margin: 0,
};

const descStyle: React.CSSProperties = {
  fontSize: "14px",
  color: "var(--cadetGrey)",
  lineHeight: 1.6,
  margin: 0,
};
